module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp13_5.a9261e05.png";